import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAmazonlumberyardComponent } from './simple-icons-amazonlumberyard.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAmazonlumberyardComponent ],
    exports:      [ SimpleIconsAmazonlumberyardComponent ],
    bootstrap:    []
})
export class SimpleIconsAmazonlumberyardModule {}
